module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('SidebarHeader'), _vm._v(" "), _c('SidebarForm'), _vm._v(" "), _c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_vm._l((_vm.navItems), function(item, index) {
    return (_vm.checkAdminType(item)) ? [(item.title) ? [_c('SidebarNavTitle', {
      key: index,
      attrs: {
        "name": item.name,
        "classes": item.class,
        "wrapper": item.wrapper
      }
    })] : (item.divider) ? [_c('SidebarNavDivider', {
      key: index,
      attrs: {
        "classes": item.class
      }
    })] : (item.label) ? [_c('SidebarNavLabel', {
      key: index,
      attrs: {
        "name": item.name,
        "url": item.url,
        "icon": item.icon,
        "label": item.label,
        "classes": item.class
      }
    })] : [(item.children) ? [_c('SidebarNavDropdown', {
      key: index,
      attrs: {
        "name": item.name,
        "url": item.url,
        "icon": item.icon
      }
    }, [_vm._l((item.children), function(childL1, index) {
      return [(childL1.children) ? [_c('SidebarNavDropdown', {
        key: index,
        attrs: {
          "name": childL1.name,
          "url": childL1.url,
          "icon": childL1.icon
        }
      }, _vm._l((childL1.children), function(childL2, index2) {
        return _c('li', {
          key: index2,
          staticClass: "nav-item"
        }, [_c('SidebarNavLink', {
          attrs: {
            "name": childL2.name,
            "url": childL2.url,
            "icon": childL2.icon,
            "badge": childL2.badge,
            "variant": item.variant
          }
        })], 1)
      }), 0)] : [(_vm.checkAdminType(childL1)) ? _c('SidebarNavItem', {
        key: index,
        attrs: {
          "classes": item.class
        }
      }, [_c('SidebarNavLink', {
        attrs: {
          "name": childL1.name,
          "url": childL1.url,
          "icon": childL1.icon,
          "badge": childL1.badge,
          "variant": item.variant
        }
      })], 1) : _vm._e()]]
    })], 2)] : [_c('SidebarNavItem', {
      key: index,
      attrs: {
        "classes": item.class
      }
    }, [_c('SidebarNavLink', {
      attrs: {
        "name": item.name,
        "url": item.url,
        "icon": item.icon,
        "badge": item.badge,
        "variant": item.variant
      }
    })], 1)]]] : _vm._e()
  })], 2), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('SidebarFooter'), _vm._v(" "), _c('SidebarMinimizer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-1d86f3bf!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/Sidebar.vue
// module id = toq3
// module chunks = 4